module.exports = __webpack_public_path__ + "img/logout.459df7b8.png";